import React, { ReactElement } from 'react';
import { Clock } from 'react-bootstrap-icons';

import ChangeIcon from '../../../../General/ChangeIcon';

import { NewsType } from '../../../../../Enum/Interest/NewsType';
import { UpcomingChange } from '../../../../../Interface/Response/Interest/UpcomingChange';

import { formatPercent } from '../../../../../Helpers/Percent';
import { capitalizeFirstLetter } from '../../../../../Helpers/String';
import { convertStringToDutchString } from '../../../../../Helpers/Date';

interface Props {
    change: UpcomingChange | null;
}

const UpcomingChangeIcon: React.FC<Props> = ({ change }: Props) => {
    const getIcon = (): ReactElement => {
        switch (change?.type) {
            case NewsType.LOWERED:
                return <Clock className="groen ml-1" />;
            case NewsType.UPPED:
                return <Clock className="rood ml-1" />
            default:
                return <div className="empty-icon ml-1" />;
        }
    }

    if (change === null || change === undefined) {
        return <div className="empty-icon ml-1" />;
    }

    return (
        <ChangeIcon
            title={capitalizeFirstLetter(change.type)}
            content={<>Op <strong>{convertStringToDutchString(change.date)}</strong> vindt er een <strong>{change.type}</strong> van deze rente plaats naar <strong>{formatPercent(change.percentage)}</strong>.</>}
            icon={getIcon()}
        />
    );
};

export default UpcomingChangeIcon;
